// extracted by mini-css-extract-plugin
export var success = "style-module--success--1_Uf3";
export var success_suptitle = "style-module--success_suptitle--11p3E";
export var success_title = "style-module--success_title--ici8n";